import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { DpDatePickerModule } from 'ng2-date-picker';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatTimepickerModule } from '@angular-material-components/datetime-picker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { DatetimeRangePickerComponent } from './datetime-range-picker.component';
import { MaterialModule } from 'src/app/shared/material.module';

@NgModule({
    declarations: [DatetimeRangePickerComponent],
    imports: [
        CommonModule,
        RouterModule,
        DpDatePickerModule,
        NgxDaterangepickerMd.forRoot(),
        NgxMatDatetimePickerModule,
        NgxMatTimepickerModule,
        NgxMatNativeDateModule,
        MatFormFieldModule,
        NgbModule, FormsModule,
        ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
        ToastrModule.forRoot(
            {
                timeOut: 2000
            }
        ),
    ],
    exports: [DatetimeRangePickerComponent,
        MaterialModule
    ],
    providers: [
        ToastrService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DatePickerModule { }
